/* react-i18next with ICU from day one (§20).
 *
 * From day one rather than "when we localise", because retrofitting ICU means revisiting every
 * string that turned out to need a plural or a number format — and the ones that need it are
 * exactly the ones already shipped and screenshotted.
 */

import i18next from 'i18next';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';

export const defaultNamespace = 'common';

/* Locale bundles are imported statically, not fetched. Hard rule 13: an air-gapped deployment
 * has no CDN to lazy-load from, so a runtime fetch would work in development and fail in the
 * market this product is sold into. */
await i18next
  .use(ICU)
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    defaultNS: defaultNamespace,
    ns: [defaultNamespace],
    resources: { en: { [defaultNamespace]: en } },
    interpolation: { escapeValue: false },
    returnNull: false,
  });

export default i18next;
